module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/bonus-pict-9e1c7652f998a2834d3ec8b616067294.jpg";